import React, {useEffect, useState, useRef} from 'react';
import Footer from '../../../shared/Footer';
import "./projects-detail-page.css";
import { Fade } from 'react-reveal';
import { Waypoint } from 'react-waypoint';
import victory0 from '../../../images/projects/Victory/victoryt.jpg';
import victory1 from '../../../images/projects/Victory/victory1.jpg';
import victory2 from '../../../images/projects/Victory/victory2.jpg';
import victory3 from '../../../images/projects/Victory/victory3.jpg';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import {responsive} from './Carousel.js';

export default function Victory() {
    document.title = "VICTORY RESIDENCE Polyfunkčný objekt  - kyska.sk";

    const [animationTriggered, setAnimationTriggered] = useState(false);

    const handleWaypointEnter = () => {
      setAnimationTriggered(true);
    };

    const carouselRef = useRef(null);

    const handlePrevClick = (event) => {
        event.preventDefault();
        carouselRef.current.previous();
    };

    const handleNextClick = (event) => {
        event.preventDefault();
        carouselRef.current.next();
    };

    return (
        <div>
            <Waypoint onEnter={handleWaypointEnter}>
            <Fade duration={1000}>
                <h3 className="top-heading"></h3>

                <div className='carousel-container'>
                    <Carousel
                        responsive={responsive}
                        infinite={true}
                        draggable={false}
                        ref={carouselRef}
                        autoPlay={10000}
                        arrows={false}
                        >

                        <img
                            className="img-fluid"
                            src={victory0}
                            alt="First slide"
                        />

                        <img
                            className="img-fluid"
                            src={victory1}
                            alt="Second slide"
                        />
                        
                        <img
                            className="img-fluid"
                            src={victory2}
                            alt="Third slide"
                        />
                    
                        <img
                            className="img-fluid"
                            src={victory3}
                            alt="Fourth slide"
                        />
                    </Carousel>
                </div>

                <div className="carousel-controls">
                    <a
                        className="carousel-control-prev-a"
                        href="#carousel"
                        role="button"
                        onClick={handlePrevClick}
                    >
                        <span className="carousel-control-prev-icon" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" class="bi bi-chevron-compact-left" viewBox="0 0 16 16" preserveAspectRatio="none">
                                <path fill-rule="evenodd" d="M9.224 1.553a.5.5 0 0 1 .223.67L6.56 8l2.888 5.776a.5.5 0 1 1-.894.448l-3-6a.5.5 0 0 1 0-.448l3-6a.5.5 0 0 1 .67-.223z"/>
                            </svg>
                        </span>
                    </a>

                    <a
                        className="carousel-control-next-a"
                        href="#carousel"
                        role="button"
                        onClick={handleNextClick}
                    >
                        <span className="carousel-control-next-icon" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" class="bi bi-chevron-compact-right" viewBox="0 0 16 16" preserveAspectRatio="none">
                                <path fill-rule="evenodd" d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671z"/>
                            </svg>
                        </span>
                    </a>
                </div>

                
                <h3 className='detail-heading'>VICTORY RESIDENCE Polyfunkčný objekt</h3>
                <hr className='detail-hr'/>
                <p>Pôvodný objekt dvoj-podlažnej športovej ubytovne bol v z dôvodu ohrozovania okoloidúcich, po požiari z prevažnej časti asanovaný. V súčasnosti sa na časti pozemku nachádza torzo obvodového múru a v časti betónová spevnená plocha. Objekt je navrhnutý na komplexnú rekonštrukciu, s pôvodnou funkciou ubytovania pre športovcov s nadstavbou. Rekonštruovaný ubytovací objekt- apartmánový dom je riešený na prechodné a dočasné ubytovanie formou apartmánových prenajímateľných ubytovacích jednotiek a s kanceláriami a spoločenskými priestormi. Rieši aj závažný problém statickej dopravy dobudovaním podzemnej garáže, ktorá do značnej miery prispeje k lepšej dopravnej obslužnosti okolia a dnešným štandardom.</p>
                <br></br>

                <hr className="project-detail-hr"></hr>
                <div className="project-detail-table" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>Rok realizácie</div>
                    <div>V príprave</div>
                </div>
                <hr className="project-detail-hr"></hr>

                <div className="project-detail-table" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>Výkon</div>
                    <div>Kompletné inžinierske a projekčné práce</div>
                </div>
                <hr className="project-detail-hr"></hr>

                <div className="project-detail-table" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>Stavebník</div>
                    <div>Právnická osoba</div>
                </div>
                <hr className="project-detail-hr"></hr>

                <div className="project-detail-table" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>Lokalita</div>
                    <div>Bratislava – Nové mesto</div>
                </div>
                <hr className="project-detail-hr"></hr>
                                
            </Fade>
            </Waypoint>

            <Footer />
        </div>
    );
}

